import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ScoreLegendComponent } from "../common/score-legend/score-legend.component";
import { ValidityScoreComponent } from "../common/validity-score/validity-score.component";
import {jsPDF} from 'jspdf';
import html2canvas from 'html2canvas';
import { DataService } from '../services/data.service';
import { PopoverClose, PopoverComponent, PopoverModule, PopoverTemplate } from '@ngx-popovers/popover';
import { TruncateTextWidthDirective } from '../common/directives/truncate.directive';
import { MatDialog } from '@angular/material/dialog';
import { SaveReportPopupComponent } from '../common/popups/save-report-popup/save-report-popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../services/http.service';

import { Clipboard } from '@angular/cdk/clipboard';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ClickOutsideDirective } from '../common/directives/click-outside.directive';
import { AppConstants } from '../../constants/app.constants';
import { LinksDialogComponent } from '../links-dialog/links-dialog.component';
import { ProgressBarLoaderComponent } from '../common/progress-bar-loader/progress-bar-loader.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { Document, Packer, Paragraph, Table, TableCell, TableRow, TextRun, ExternalHyperlink, WidthType, HeadingLevel } from 'docx';
import { EditClaimchartPopupComponent } from '../common/popups/edit-claimchart-popup/edit-claimchart-popup.component';
import { saveAs } from 'file-saver';
declare var html2pdf: any;

@Component({
  selector: 'app-sniff-report',
  standalone: true,
  imports: [CommonModule, ScoreLegendComponent, ValidityScoreComponent, PopoverClose, PopoverComponent, PopoverTemplate, PopoverModule, TruncateTextWidthDirective, MatCardModule, MatIconModule, MatProgressSpinnerModule, ClickOutsideDirective, ProgressBarLoaderComponent],
  templateUrl: './sniff-report.component.html',
  styleUrl: './sniff-report.component.css',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class SniffReportComponent {

  
  @Input () inputData:any=[];
  @Input () validitySkip:boolean=false;
  @Input () infringementData:any=[];
  @Input () validityData:any=[];
  @Input () industryData:any=[];

  @Input() currentReportMode:any=null;
  
  @Input() onClickCancel:any=null;
  

  exportUI:boolean=false;
  exportingState=false;

  shareReport=false;
  isLoading=false;
reportId:any=''
  projectId:any=null;
  constructor(
    private dataService: DataService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private httpService: HttpService,
    private clipboard: Clipboard,
    private router: Router
  ) { 
    console.log('sniff report initiated');
    const reportId = this.route.snapshot.queryParamMap.get('reportId');
    const projectId=this.route.snapshot.queryParamMap.get('projectId');
    this.projectId=projectId;
    this.reportId=reportId;
    const shareId=this.route.snapshot.queryParamMap.get('shareId');
    const username=this.dataService.username;
    if (reportId) {
      this.isLoading=true;
      this.httpService.get(`/workflows/${projectId}/${reportId}?userId=${username}`)
        .then((data: any) => {
          console.log('report data:', data)
          this.inputData = data.patentData;
          this.infringementData = data.infringementData;
          this.validityData = data.pasData;
          this.industryData = data.industryData;

          this.currentReportMode = data.workflowType.toLowerCase();
          console.log('current report mode:', this.currentReportMode)
          console.log('Input data:', this.inputData)
          console.log('Infringement data:', this.infringementData)
          console.log('Validity data:', this.validityData)
          console.log('Industry data:', this.industryData)
          if (this.currentReportMode == 'infringement') {
            this.validitySkip = true;
          } else {
            this.validitySkip = false;
          }
          this.initializeData();
          this.isLoading=false;
        })
        .catch(error => {
          this.isLoading=false;
          console.error('Error fetching report details:', error);
        });
    }
    else if (shareId){
      this.shareReport=true;
      this.isLoading=true;
      this.httpService.get(`/workflow/share/data?shareID=${shareId}&userId=${username}`)
      .then((data: any) => {
        console.log('report data:', data)
        data=data.data
        this.inputData = data.patentData;
        this.infringementData = data.infringementData;
        this.validityData = data.pasData;
        this.industryData = data.industryData;

        this.currentReportMode = data.workflowType.toLowerCase();
        console.log('current report mode:', this.currentReportMode)
        console.log('Input data:', this.inputData)
        console.log('Infringement data:', this.infringementData)
        console.log('Validity data:', this.validityData)
        console.log('Industry data:', this.industryData)
        if (this.currentReportMode == 'infringement') {
          this.validitySkip = true;
        } else {
          this.validitySkip = false;
        }
        this.initializeData();
        this.isLoading=false;
      })
      .catch(error => {
        console.error('Error fetching report details:', error);
        this.isLoading=false;
      });

    } 
    else {
      console.log('current report mode:', this.currentReportMode, this.dataService.activeReport)
      if (this.currentReportMode == null) {
        this.currentReportMode = this.dataService.activeReport;
      }
      this.inputData = this.dataService.inputData;
      this.validityData = this.dataService.pasData;
      this.industryData = this.dataService.industryData;
      this.infringementData = this.dataService.infringementData;
      this.validitySkip = this.dataService.skipPas;
      if (this.currentReportMode == 'infringement') {
        this.validitySkip = true;
      } else {
        this.validitySkip = false;
      }
      console.log('skip pas:', this.validitySkip, this.dataService.skipPas);
      this.initializeData();
    }
  }
  currentTab="industry";

  @Input () selectedPatentIndex:any=null;
  infringementArray:any[]=[];
  claimChartData:any[]=[];
  isEditingCompanies=false;

  ngOnInit(){
    // this.validitySkip=this.dataService.skipPas;
    const reportId = this.route.snapshot.queryParamMap.get('reportId');
    // alert('Report ID: '+reportId)
    if(!reportId){
      // alert('in')
    this.inputData=this.dataService.inputData;
    this.validityData=this.dataService.pasData;
    this.industryData=this.dataService.industryData;
    this.infringementData=this.dataService.infringementData;
    console.log('inputdata', this.inputData)
    console.log('infringement data',this.infringementData)
    console.log('industry data', this.industryData)
    console.log(this.validityData.referenceTableMap)
    this.infringementArray=this.infringementData.patentDetails;
    this.claimChartData=this.infringementData.claimChartData;

    if(this.currentReportMode=='infringement'){
      this.currentTab='industry';
      this.validitySkip=true;
    }
    else{
      this.currentTab='pas';
    }
    this.sortData();
    this.saveReportData();
  }
  let selectedPatentIndexCandidate= this.route.snapshot.queryParamMap.get('selectedPatentIndex');
  if( selectedPatentIndexCandidate&& selectedPatentIndexCandidate!='null'){
    this.selectedPatentIndex=parseInt(selectedPatentIndexCandidate);
    console.log('selected patent index:', this.selectedPatentIndex)
  }

  this.handleEventListeners();
  }

  ngOnDestroy() {
    this.removeEventListeners();
  }

  initializeData() {
    this.infringementArray=this.infringementData.patentDetails;
    this.claimChartData=this.infringementData.claimChartData;
    this.currentTab = this.currentReportMode == 'infringement' ? 'industry' : 'pas';
    if(this.currentReportMode=='infringement'){
      this.currentTab='industry';
      this.validitySkip=true;
    }
    else{
      this.currentTab='pas';
    }
    this.sortData();
  }

  keyEventListener:any=null;
  handleEventListeners(){
    this.keyEventListener = (event:any) => {  
      if(event.key=='ArrowLeft'){
        this.changeIndex(-1);
      }
      else if(event.key=='ArrowRight'){
        this.changeIndex(1);
      }
      else if(event.key=='Backspace'||event.key=='Escape'){
        this.selectedPatentIndex=null;
      }
    }
    document.addEventListener('keyup', this.keyEventListener);
  }

  removeEventListeners(){
    if(this.keyEventListener){
      document.removeEventListener('keyup', this.keyEventListener);
      this.keyEventListener=null;
    }
  }

  sortData(){
    this.industryData.sort((a:any, b:any) => {
      const indexA = this.inputData.findIndex((item:any) => item.patentNumber === a.patentNumber);
      const indexB = this.inputData.findIndex((item:any) => item.patentNumber === b.patentNumber);
      return indexA - indexB;
    })
    if(this.currentReportMode=='infringement'||this.currentReportMode=='full')
    {
      this.claimChartData.sort((a:any, b:any) => {
        const indexA = this.inputData.findIndex((item:any) => item.patentNumber === a.patent_number);
        const indexB = this.inputData.findIndex((item:any) => item.patentNumber === b.patent_number);
        return indexA - indexB;
      })
      this.infringementArray.sort((a:any, b:any) => {
        const indexA = this.inputData.findIndex((item:any) => item.patentNumber === a.patentNumber);
        const indexB = this.inputData.findIndex((item:any) => item.patentNumber === b.patentNumber);
        return indexA - indexB;
      })
    }
    if(this.currentReportMode=='pas'||this.currentReportMode=='full')
    {
      this.validityData.summaryData.sort((a:any, b:any) => {
        const indexA = this.inputData.findIndex((item:any) => item.patentNumber === a.patentNumber);
        const indexB = this.inputData.findIndex((item:any) => item.patentNumber === b.patentNumber);
        return indexA - indexB;
      })
    }
  }

  cancelClickDefault(){
    if(this.onClickCancel!=null){
      this.onClickCancel();
    }
    else {
      window.history.back();
    }
  }

  getFilteredClaimChartData(patentNumber:string){
    return this.claimChartData.filter((item:any)=>item.patent_number==patentNumber)
  }

  getNonZeroClaimCharts(claimChartData:any){
    // console.log('claimChartData', claimChartData)
    return claimChartData.filter((item:any)=>item.score>0)
  }
assistMode=false;
  getIndustryDataForClaimData(claimData:any){
    let patentNumbers=claimData.map((item:any)=>item.patent_number);
    let products= claimData.map((item:any)=>item.targeted_product);
    // console.log('claimdata products',products)
    // match with product name and patent number
    // industry data is an array of objects with patentnumber and companies. companies contains products. product is an obect of name and sourcelink
    // console.log('claimdata:', this.industryData);
    let industryData=this.industryData.filter((item:any)=>patentNumbers.includes(item.patentNumber));
    let filteredIndustryData:any[]=[];
    industryData.forEach((item:any)=>{
      let companiesArray:any=[]
      item.companies.forEach((company:any)=>{
        let productsArray:any=[]
        company.products.forEach((product:any)=>{
          if(products.includes(product.name)){
            productsArray.push(product);
          }
        })
        if(productsArray.length>0){
          companiesArray.push({
            name:company.name,
            products:productsArray
          });
        }
      }
      )
      if(companiesArray.length>0){
        filteredIndustryData.push({
          patentNumber:item.patentNumber,
          companies:companiesArray
        });
      }
       
    });
    // console.log('filtered industry data:', filteredIndustryData);
    return filteredIndustryData;
  } 

  getIndustryDataForPatentNumber(patentNumber:string){
    return this.industryData.filter((item:any)=>item.patentNumber==patentNumber)[0];
  }

  getZeroClaimCharts(claimChartData:any){
    return claimChartData.filter((item:any)=>item.score==0)
  }

  getFilteredIndustryData(patentNumber:string){
    return this.industryData.filter((item:any)=>item.patentNumber==patentNumber)
  }

  getSummaryData(patentNumber:any){
    return this.validityData.summaryData.filter((item:any)=>item.patentNumber==patentNumber)
  }

  getValidityScoreCount(){
    if(this.validitySkip)
      return 0;
    return this.validityData.summaryData.filter((x:any)=>x.score>7).length
  }

  getValidityScore(patentNumber:any){
    return this.validityData.summaryData.filter((item:any)=>item.patentNumber==patentNumber)[0].score
  }
  referenceTableOpenMapObj:any={};
  toggleReferenceTable(patentNumber:any, referenceNumber:any){
    
    if(!this.referenceTableOpenMapObj[patentNumber]){
      this.referenceTableOpenMapObj[patentNumber]={};
      this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
    }
    else{
      if(!this.referenceTableOpenMapObj[patentNumber][referenceNumber]){
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else{
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
      }
    }
  }

  
get allExpandedPas(){
  if(this.validitySkip){
    return true;
  }
  if(this.validityData.summaryData.length==0){
    return false;
  }
  for(let i=0;i<this.validityData.summaryData.length;i++){
    let patentNumber=this.validityData.summaryData[i].patentNumber;
    if(!this.referenceTableOpenMapObj[patentNumber]){
      return false;
    }
    let referenceNumbers=Object.keys(this.validityData.referenceTableMap[patentNumber]);
    for(let j=0;j<referenceNumbers.length;j++){
      if(!this.referenceTableOpenMapObj[patentNumber][referenceNumbers[j]]){
        return false;
      }
    }
  }
  return true;
}

  toggleAllPasReferences(){
    if(this.allExpandedPas){
      this.referenceTableOpenMapObj={};
    }
    else{
      for(let i=0;i<this.validityData.summaryData.length;i++){
        let patentNumber=this.validityData.summaryData[i].patentNumber;
        if(!this.referenceTableOpenMapObj[patentNumber]){
          this.referenceTableOpenMapObj[patentNumber]={};
        }
        let referenceNumbers=Object.keys(this.validityData.referenceTableMap[patentNumber]);
        for(let j=0;j<referenceNumbers.length;j++){
          this.referenceTableOpenMap(patentNumber, referenceNumbers[j], j);
        }
      }
    }
  }



  referenceTableOpenMap(patentNumber:any, referenceNumber:any, index:any){
    // map based on patentNumber and further referenceNumber. If the reference Object does not exist, create a new object with the referenceNumber as key and value as false
    if(!this.referenceTableOpenMapObj[patentNumber]){
      if(index==0&&this.referenceTableOpenMapObj[patentNumber]===undefined){
        this.referenceTableOpenMapObj[patentNumber]={};
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else
      this.referenceTableOpenMapObj[patentNumber]={};
    }
    else{
      if(!this.referenceTableOpenMapObj[patentNumber][referenceNumber]){
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else{
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
      }
    }
    return this.referenceTableOpenMapObj[patentNumber][referenceNumber];
  }

  getScoreValue(){
    if(this.selectedPatentIndex!=null){
      if(this.currentTab=='pas')
        return this.getValidityScore(this.inputData[this.selectedPatentIndex].patentNumber)

      return this.infringementData['patentInfringementScoreData'][this.inputData[this.selectedPatentIndex].patentNumber]
    }
    return 0;
  }

  isScoreMid(){
    if(this.selectedPatentIndex!=null){
      let score=this.getScoreValue();
      if( score>=4&&score<=6){
        return true;
      }
    }
    return false;
  }

  isScoreHigh(){
    if(this.selectedPatentIndex!=null){
      let score=this.getScoreValue();
      if( this.currentReportMode!='pas'&&score>=7){
        return true;
      }
      else if(this.currentReportMode=='pas'&&score>=4){
        return true;
      }
    }
    return false;
  }

  setSelectedPatentIndex(patentNumber:string){
    console.log(patentNumber)
    let index=this.inputData.findIndex((item:any)=>item.patentNumber==patentNumber);
    this.selectedPatentIndex=index;
    this.router.navigate([], {
      queryParams: { selectedPatentIndex: index },
      queryParamsHandling: 'merge', // merge with existing query params
    });
    console.log(index, this.inputData[index])
  }

  exportPDF(){
    this.exportingState=true;
    this.exportUI=true;
    setTimeout(() => {
    var element:any = document.getElementById('exportable-ui');
    
    if(this.selectedPatentIndex!=null){
      element=document.getElementById('major-report');
      console.log(element)
    }
    element.classList.add('min-height');
    let opt={
      filename:'sniff-report.pdf',
      width: 2500,
      height:100,

    }
      
    //      //$("#previewBeforeDownload").html(canvas);
    //      var imgData = canvas.toDataURL("image/jpeg",1);
    //      var pdf = new jsPDF("p", "px", "a2");
    //      // var pageWidth = pdf.internal.pageSize.getWidth();
    //      var pageWidth=pdf.internal.pageSize.getWidth();
    //      var pageHeight = pdf.internal.pageSize.getHeight();
    //      var imageWidth = canvas.width;
    //      var imageHeight = canvas.height;
   
    //      var ratio = imageWidth/imageHeight >= pageWidth/pageHeight ? pageWidth/imageWidth : pageHeight/imageHeight;
    //      //pdf = new jsPDF(this.state.orientation, undefined, format);
    //      pdf.addImage(imgData, 'JPEG', 0, 0, imageWidth * ratio, imageHeight * ratio);
    //      pdf.save("sniff-report.pdf");
    //  });
   // Get the dimensions of the HTML element
const elementHeight = element.offsetHeight;
const elementWidth = element.offsetWidth;

// Estimate the timeout based on the element's height (e.g., 1ms per pixel)
const estimatedTimeout = elementHeight * 1; // Adjust the multiplier as necessary

// html2canvas(element).then(canvas => {
//   var imgData = canvas.toDataURL("image/jpeg", 1);
  
//   // Get the dimensions of the canvas
//   var imageWidth = canvas.width;
//   var imageHeight = canvas.height;

//   // Calculate the required PDF dimensions
//   var pdfWidth = imageWidth;
//   var pdfHeight = imageHeight;
//   console.log('page dimensions:', pdfWidth, pdfHeight)
//   console.log('canvas details', imageWidth, imageHeight)
//   console.log('canvas details', canvas.width, canvas.height)

//   // Create the PDF with the calculated dimensions
//   var pdf = new jsPDF("p", "px", [pdfWidth, pdfHeight]);

//   // Add the image to the PDF
//   pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

//   // Save the PDF
//   pdf.save("sniff-report.pdf");
// }).finally(() => {
//   // setTimeout(() => {
//     this.exportingState = false;
//     this.exportUI = false;
//     element.classList.remove('min-height');
//   // }, estimatedTimeout); // Use the estimated timeout
// });
html2canvas(element, { scale: 2 }).then(canvas => {
  // Convert the canvas to image data
  let scalingFactor=0.25;
  if(canvas.width>3000)
  {
    scalingFactor=1;
  }
  console.log('scaling factor', scalingFactor)
  var imgData = canvas.toDataURL("image/jpeg", scalingFactor);

  // Create a new jsPDF instance using A4 page size and "pt" as unit.
  // (You can change "a4" to a custom format if desired.)
  var pdf = new jsPDF("p", "pt", "a4");

  // Get the PDF page dimensions (width and height in points)
  var pageWidth = pdf.internal.pageSize.getWidth();
  var pageHeight = pdf.internal.pageSize.getHeight();

  // Calculate the image width and height for the PDF such that the image's width fits the page width.
  // This ensures the aspect ratio is maintained.
  var imgWidth = pageWidth;
  var imgHeight = canvas.height * pageWidth / canvas.width;

  // Initialize the position for the first image slice.
  var position = 0;
  var heightLeft = imgHeight;

  // Add the first slice of the image to the PDF.
  pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
  heightLeft -= pageHeight;

  // As long as there is remaining image height, create additional pages.
  while (heightLeft > 0) {
    // Move the position upward (a negative offset shifts the image for the new page).
    position = position - pageHeight;
    // Add a new page to the PDF.
    pdf.addPage();
    // Insert the image again with the new offset so that the next slice appears.
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
    heightLeft -= pageHeight;
  }

  // Save the PDF
  pdf.save("sniff-report.pdf");
}).finally(() => {
  // Reset states and clean up UI
  this.exportingState = false;
  this.exportUI = false;
  element.classList.remove('min-height');
});


    }, 10);
    }

    calculateInfringedCompanies(){
        
    }

    calculateRevenue(){
      
    }

    changeIndex(index:number){
      if(this.selectedPatentIndex+index>=0 && this.selectedPatentIndex+index<this.inputData.length){
        this.selectedPatentIndex+=index;
      }
    }

    backIndex(){
        this.selectedPatentIndex=null;
        this.router.navigate([], {
          queryParams: { selectedPatentIndex: null },
          queryParamsHandling: 'merge', // merge with existing query params
        });
    }

    getNonZeroPatents(){
      // filter industry data based on patentnumbers on claimchartscore data of >0
      let scoreData=this.infringementData.patentInfringementScoreData;
      let patentNumbers=Object.keys(scoreData).filter((item:any)=>scoreData[item]>0);
      let filteredIndustryData=this.industryData.filter((item:any)=>patentNumbers.includes(item.patentNumber));
      return filteredIndustryData;
    }

    getRevenueDetails(){
      let revenueArray:any=[];
      let revenueArrayWithoutZero:any=[];
      // console.log(this.infringementData)
      for (const inputItem of this.inputData) {
        let dataItem=this.getIndustryDataForClaimData(this.getNonZeroClaimCharts(this.getFilteredClaimChartData(inputItem.patentNumber)));
        // console.log('dataItem:', dataItem)
        revenueArrayWithoutZero.push(...dataItem);
      }

      // console.log('revenueArrayWithoutZero:', revenueArrayWithoutZero)

      let industryDataWithoutZero=this.getNonZeroPatents();
      industryDataWithoutZero.forEach((element:any) => {
      // revenueArrayWithoutZero.forEach((element:any) => {
      // this.industryData.forEach((element:any) => {
        let dataArray=element.companies;
      for(let data of dataArray){
        let companyData={
          name:data.name,
          products:[]
        }
        for(let product of data.products){
          // console.log('product:', product)
          revenueArray.push(product.revenue.response)
        }
      }
    });

      // console.log(revenueArray)
      let revenueString=this.sumCurrencies(revenueArray);
      // console.log(revenueString)
      return revenueString;


    }

     sumCurrencies(values: any[]) {
      const denominations: any = {
          M: 1e6
      };
  
      let total = 0;
  
      for (let value of values) {
          value = value.split(/[\(\[]/)[0]; // Remove anything after ( or [
  
          // Match formats like "$100M USD" or "$100M - $500M USD"
          const match = value.match(/\$([\d,.]+)M(?:\s*[-–]\s*\$([\d,.]+)M)?\s*USD/i);
          if (!match) continue;
  
          const start = parseFloat(match[1].replace(/,/g, ""));
          const end = match[2] ? parseFloat(match[2].replace(/,/g, "")) : null;
        console.log('match value:', value, match, start, end)
          if (end) {
              total += ((start + end) / 2) * denominations.M;
              console.log((start + end) / 2, 'M')
          } else {
              total += start * denominations.M;
              console.log(start, 'M')
          }
      }
  
      if (total >= 1e9) {
          const totalInBillions = total / 1e9;
          const truncated = Math.floor(totalInBillions * 10) / 10;
          const hasExtra = (totalInBillions * 100) % 10 > 0;
          return hasExtra
              ? `$${truncated.toFixed(1)}+ B`
              : `$${truncated.toFixed(1)} B`;
      } else {
          const totalInMillions = total / 1e6;
          const truncated = Math.floor(totalInMillions * 10) / 10;
          const hasExtra = (totalInMillions * 100) % 10 > 0;
          return hasExtra
              ? `$${truncated.toFixed(1)}+ M`
              : `$${truncated.toFixed(1)} M`;
      }
  }
  
    getLinkOrAiEstimate(str:any){
      console.log('str:', str)
      if(typeof str !== 'string'&&!str.length){
        return "Unknown";
      }
      else if(typeof str !=='string'&&str.length){
        return `<ol>${str.map((item:any) => `<li>${item.includes('http')?'<a href='+item+'>'+item+'</a>':item}</li>`).join('')}</ol>`;
      }
      if(!str){
        return "Unknown";
      }
      if(str.includes('http')){
        return `<a href=${str} target="_blank">${str}</a>`
      }
      else if(str=='Unknown')
      {
        return "Unknown";
      }
      else{
        let target = str.split('(')[1];
        if(!target){
          return str;
        }
        target = target.slice(0, -1);
        return `<h6>AI Estimate</h6> <p>${target}</p>`
      }
    }
    getRevenueSumDetails(patent:any) {
      let revenueArray: any[] = [];
      
      // Iterate over the passed products array to collect revenue responses.
      patent.companies.forEach((company: any) => {
        company.products.forEach((product: any) => {
        revenueArray.push(product.revenue.response);
      });});
    
      // console.log(revenueArray);
      const revenueRange = this.sumCurrenciesRange(revenueArray);
      // console.log(revenueRange);
      return revenueRange;
    }
    
    sumCurrenciesRange(values: any[]) {
      const M = 1e6;
      let totalMin = 0;
      let totalMax = 0;
    
      for (let value of values) {
        // Remove annotations/comments like (text) or [text]
        value = value.split(/[\(\[]/)[0];
    
        // Match only values like "$100M USD" or "$100M - $500M USD"
        const match = value.match(/\$([\d,.]+)M(?:\s*[-–]\s*\$([\d,.]+)M)?\s*USD/i);
        if (!match) continue;
    
        const start = parseFloat(match[1].replace(/,/g, ""));
        const end = match[2] ? parseFloat(match[2].replace(/,/g, "")) : null;
    
        if (end) {
          totalMin += start * M;
          totalMax += end * M;
        } else {
          const val = start * M;
          totalMin += val;
          totalMax += val;
        }
      }
    
      if (totalMax >= 1e9) {
        const minInB = totalMin / 1e9;
        const maxInB = totalMax / 1e9;
        const truncatedMin = Math.floor(minInB * 10) / 10;
        const truncatedMax = Math.floor(maxInB * 10) / 10;
        return `$${truncatedMin.toFixed(1)} B - $${truncatedMax.toFixed(1)} B`;
      } else {
        const minInM = totalMin / M;
        const maxInM = totalMax / M;
        const truncatedMin = Math.floor(minInM * 10) / 10;
        const truncatedMax = Math.floor(maxInM * 10) / 10;
        return `$${truncatedMin.toFixed(1)} M - $${truncatedMax.toFixed(1)} M`;
      }
    }
    
/**
 * getInvalidityStats()
 * Computes summary statistics from the summaryData array.
 * It calculates the total number of patents, and counts how many fall into low (score 1–3),
 * medium (score 4–6), and high (score 7–10) invalidity ranges.
 */
getInvalidityStats() {
  let total = this.validityData.summaryData.length;
  let lowCount = 0;   // Score 1-3
  let midCount = 0;   // Score 4-6
  let highCount = 0;  // Score 7-10

  this.validityData.summaryData.forEach((p: any) => {
    const s = p.score || 0;
    if (s >= 0 && s <= 3) lowCount++;
    else if (s >= 4 && s <= 6) midCount++;
    else if (s >= 7) highCount++;
  });

  return { total, lowCount, midCount, highCount };
}

getInfringementStats(){

  let total = this.infringementData['patentInfringementScoreData'].length;
  let lowCount = 0;   // Score 1-3
  let midCount = 0;   // Score 4-6
  let highCount = 0;  // Score 7–10

  Object.keys(this.infringementData['patentInfringementScoreData']).forEach((patentNumber: any) => {
    const s = this.infringementData['patentInfringementScoreData'][patentNumber] || 0;
    if (s > 0 && s <= 3) lowCount++;
    else if (s >= 4 && s <= 6) midCount++;
    else if (s >= 7) highCount++;
  });

  return { total, lowCount, midCount, highCount };
}

get infringeOrFullReport(){
  if(this.currentReportMode=='infringement'||this.currentReportMode=='full'){
    return true
  }
  return false;
}

referenceDivOpenMapObj:any={};

referenceDivOpenMap(patentNumber:any, index:any){

  if(this.exportingState){
    return true;
  }

  if(!this.referenceDivOpenMapObj[patentNumber]){
    if(index==0&&this.referenceDivOpenMapObj[patentNumber]===undefined){
      this.referenceDivOpenMapObj[patentNumber]=true;
    }
    else
    this.referenceDivOpenMapObj[patentNumber]=false;
  }
  else{
    this.referenceDivOpenMapObj[patentNumber]=true;
  }
  return this.referenceDivOpenMapObj[patentNumber];
}

toggleReferenceDiv(patentNumber:any){
  this.referenceDivOpenMapObj[patentNumber]=!this.referenceDivOpenMapObj[patentNumber];
  console.log('referenceDivOpenMapObj:', this.referenceDivOpenMapObj)
}

get allExpanded(){
  let claimData=this.getFilteredClaimChartData(this.inputData[this.selectedPatentIndex].patentNumber);
  if(!claimData||claimData.length==0){
    return false;
  }
  let allExpanded=true;
  claimData.forEach((item:any, i:any)=>{
    if(!this.referenceDivOpenMapObj[item.patent_number+''+i]){
      allExpanded=false;
    }
  });
  return allExpanded;
}

expandAllReferences() {
  let claimData=this.getFilteredClaimChartData(this.inputData[this.selectedPatentIndex].patentNumber);
  
  // loop through and update referencedivopenmapobj
  console.log(claimData)
  
  if(!this.allExpanded){
  this.referenceDivOpenMapObj={};
  claimData.forEach((item:any, i:any)=>{
    if(!this.referenceDivOpenMapObj[item.patent_number+''+i]){
      this.referenceDivOpenMapObj[item.patent_number+''+i]=true;
    }
  });
  console.log('all expanded:', this.referenceDivOpenMapObj)
}
else{
  this.referenceDivOpenMapObj={};
  claimData.forEach((item:any, i:any)=>{
    if(!this.referenceDivOpenMapObj[item.patent_number+''+i]){
      this.referenceDivOpenMapObj[item.patent_number+''+i]=false;
    }
  });
  
}
  // this.allExpanded=!this.allExpanded;
}


saveReportData(){
  this.loadingLink=true;
  console.log('save report clicked')
  let data:any={}
  let reportName:any=''
  reportName=this.dataService.candidateWorkflowName;
  // alert('Report Name: '+reportName)
  if(reportName==null){
    return;
  }
  let projectId=this.dataService.candidateProjectId;
  if(!projectId){
    return;
  }
  
  let reportAlreadySaved;
  reportAlreadySaved=window.sessionStorage.getItem('reportAlreadySaved');
  if(reportAlreadySaved=='true'){
    this.loadingLink=false;
    let reportId=window.sessionStorage.getItem('reportId');
    if(reportId){
      this.reportId=reportId;
      this.fetchShareableLink();
      this.shareCalled=true;
    }
    return;
  }
  this.dataService.workflowProgressStatus='done';
  
  this.dataService.syncWorkflow((res:any)=>{
    this.reportId=res.workflowId;
    window.sessionStorage.setItem('reportAlreadySaved', 'true');
    window.sessionStorage.setItem('reportId', this.reportId); 
    this.fetchShareableLink();
    this.shareCalled=true;
  })
  return;
  data['patentData']=this.inputData;
  data['pasData']=this.validityData;
  data['industryData']=this.industryData;
  data['infringementData']=this.dataService.infringementData;
  data['workflowName']=reportName;
  data['workflowType']=this.currentReportMode;
  data['userId']=this.dataService.username;
  data['projectId']=projectId;
  data['totalSteps']=[]
  data['status']='completed'

  console.log('reportDS', data)
  // POST /workflow 
  this.httpService.post('/workflow', data).then((res:any)=>{
    console.log(res);
    this.reportId=res.workflowId;
    window.sessionStorage.setItem('reportAlreadySaved', 'true');
    window.sessionStorage.setItem('reportId', this.reportId); 
    this.fetchShareableLink();
    this.shareCalled=true;
  });
}
showShareMenu = false;
loadingLink = false;
shareableLink = '';
shareCalled=false;

clickoutside(event: any) {
  console.log('clicked outside', event)
  if (event.value) {
    this.showShareMenu = false;
  }
}

toggleShareMenu() {
  console.log('share menu clicked')
  this.showShareMenu = !this.showShareMenu;
  if (this.showShareMenu && !this.shareableLink) {
    this.fetchShareableLink();
  }
}

exportAsPDF() {
  // Call your export PDF logic here
  console.log('Export as PDF clicked!');
}

fetchShareableLink() {
  if(this.shareCalled){
    return;
  }
  this.loadingLink = true;
  if(!this.reportId){
    this.reportId=window.sessionStorage.getItem('reportId');
  }
  this.httpService.post('/workflow/share', { workflowId:this.reportId }).then((res: any) => {
    console.log('shareable link:', res);
    // get this page's url but just the base domain url without any route or query params for example if page url is http://localhost:4200/app/sniff-report then just get http://localhost:4200
    let pageUrl = window.location.href.split('?')[0].split('#')[0].split('/').slice(0, 3).join('/');

    
    this.shareableLink = pageUrl+'/app/report?shareId='+res.shareID;

    // this.shareableLink = AppConstants.SERVER_CONFIG.URL+'/app/report?shareId='+res.shareID;
    this.loadingLink = false;
  }
  ).catch((error: any) => {
    console.error('Error fetching shareable link:', error);
    // this.loadingLink = false;
  }
  );
}

copyLink() {
  this.clipboard.copy(this.shareableLink);
  // alert('Link copied!');
  this.showCopiedFlyout();
}

onCopy() {
  console.log('Link copied to clipboard');
  this.showCopiedFlyout();
  // alert('Link copied to clipboard');
}
showCopyMessage = false;

showCopiedFlyout() {
  this.showCopyMessage = true;
  setTimeout(() => {
    this.showCopyMessage = false;
  }, 2000);
}

  openLinksDialog(product:any)
  {
    const dialogRef = this.dialog.open(LinksDialogComponent, {
      width: '600px',
      data: { links: product.technicalDocumentationLinks }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('Value received from popup:', result);
        product.technicalDocumentationLinks=result;
        // find out the product and company and update the links
        
      }
    });
  }

  
  showClaimChartMenu:any={}

 toggleClaimChartMenu(patentNumber:string){
  console.log('toggle share menu for patent number:', patentNumber, this.showClaimChartMenu[patentNumber])
    if(!this.showClaimChartMenu[patentNumber]){
      this.showClaimChartMenu[patentNumber]=true;
    }
    else{
      this.showClaimChartMenu[patentNumber]=false;
    }
  
 }

 clickOutsideShareMenu(e:any){
  console.log('clicked outside share menu', e);
  // This function is called when the user clicks outside the share menu
  // It will close all open share menus
  this.showClaimChartMenu = {};
  console.log('clicked outside share menu, closing all menus');
 }

 exportPDFWithId(id: string) {
  // this.exportingState=true;
  // this.exportUI=true;
  setTimeout(() => {
  var element:any = document.getElementById(id);
  
  // if(this.selectedPatentIndex!=null){
  //   element=document.getElementById('major-report');
  //   console.log(element)
  // }
  element.classList.add('min-height');
  let opt={
    filename:'sniff-report.pdf',
    width: 2500,
    height:100,

  }
    
  //      //$("#previewBeforeDownload").html(canvas);
  //      var imgData = canvas.toDataURL("image/jpeg",1);
  //      var pdf = new jsPDF("p", "px", "a2");
  //      // var pageWidth = pdf.internal.pageSize.getWidth();
  //      var pageWidth=pdf.internal.pageSize.getWidth();
  //      var pageHeight = pdf.internal.pageSize.getHeight();
  //      var imageWidth = canvas.width;
  //      var imageHeight = canvas.height;
 
  //      var ratio = imageWidth/imageHeight >= pageWidth/pageHeight ? pageWidth/imageWidth : pageHeight/imageHeight;
  //      //pdf = new jsPDF(this.state.orientation, undefined, format);
  //      pdf.addImage(imgData, 'JPEG', 0, 0, imageWidth * ratio, imageHeight * ratio);
  //      pdf.save("sniff-report.pdf");
  //  });
 // Get the dimensions of the HTML element
const elementHeight = element.offsetHeight;
const elementWidth = element.offsetWidth;

// Estimate the timeout based on the element's height (e.g., 1ms per pixel)
const estimatedTimeout = elementHeight * 1; // Adjust the multiplier as necessary

// html2canvas(element).then(canvas => {
//   var imgData = canvas.toDataURL("image/jpeg", 1);

//   // Get the dimensions of the canvas
//   var imageWidth = canvas.width;
//   var imageHeight = canvas.height;

//   // Calculate the required PDF dimensions
//   var pdfWidth = imageWidth;
//   var pdfHeight = imageHeight;
//   console.log('page dimensions:', pdfWidth, pdfHeight)
//   console.log('canvas details', imageWidth, imageHeight)
//   console.log('canvas details', canvas.width, canvas.height)

//   // Create the PDF with the calculated dimensions
//   var pdf = new jsPDF("p", "px", [pdfWidth, pdfHeight]);

//   // Add the image to the PDF
//   pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

//   // Save the PDF
//   pdf.save("sniff-report.pdf");
// }).finally(() => {
//   // setTimeout(() => {
//     this.exportingState = false;
//     this.exportUI = false;
//     element.classList.remove('min-height');
//   // }, estimatedTimeout); // Use the estimated timeout
// });
html2canvas(element, { scale: 2 }).then(canvas => {
// Convert the canvas to image data
let scalingFactor=0.25;
if(canvas.width>3000)
{
  scalingFactor=1;
}
console.log('scaling factor', scalingFactor)
var imgData = canvas.toDataURL("image/jpeg", scalingFactor);

// Create a new jsPDF instance using A4 page size and "pt" as unit.
// (You can change "a4" to a custom format if desired.)
var pdf = new jsPDF("p", "pt", "a4");

// Get the PDF page dimensions (width and height in points)
var pageWidth = pdf.internal.pageSize.getWidth();
var pageHeight = pdf.internal.pageSize.getHeight();

// Calculate the image width and height for the PDF such that the image's width fits the page width.
// This ensures the aspect ratio is maintained.
var imgWidth = pageWidth;
var imgHeight = canvas.height * pageWidth / canvas.width;

// Initialize the position for the first image slice.
var position = 0;
var heightLeft = imgHeight;

// Add the first slice of the image to the PDF.
pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
heightLeft -= pageHeight;

// As long as there is remaining image height, create additional pages.
while (heightLeft > 0) {
  // Move the position upward (a negative offset shifts the image for the new page).
  position = position - pageHeight;
  // Add a new page to the PDF.
  pdf.addPage();
  // Insert the image again with the new offset so that the next slice appears.
  pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
  heightLeft -= pageHeight;
}

// Save the PDF
pdf.save("sniff-report.pdf");
}).finally(() => {
// Reset states and clean up UI
// this.exportingState = false;
// this.exportUI = false;
element.classList.remove('min-height');
});


  }, 10);
  }
  
exportClaimChartToDocx(claimData: any) {

  const tableRows: TableRow[] = [];

  // Table header
  tableRows.push(new TableRow({
    children: [
      new TableCell({
        width: { size: 33.3, type: WidthType.PERCENTAGE },
        children: [new Paragraph({ children: [new TextRun({ text: "Claims", bold: true })] })],
      }),
      new TableCell({
        width: { size: 33.3, type: WidthType.PERCENTAGE },
        children: [new Paragraph({ children: [new TextRun({ text: "Infringement", bold: true })] })],
      }),
      new TableCell({
        width: { size: 33.3, type: WidthType.PERCENTAGE },
        children: [new Paragraph({ children: [new TextRun({ text: "Score", bold: true })] })],
      }),
    ],
  }));

  // Data rows
  claimData.data.forEach((claimElement: any, index: number) => {
    // Build the Infringement Column content
    const infringementParagraphs: Paragraph[] = [];

    // Analyst Comment
    if (claimElement.analyst_comment) {
      infringementParagraphs.push(
        new Paragraph({
          children: [
            new TextRun({ text: "Analyst Comment: ", bold: true }),
            new TextRun(claimElement.analyst_comment),
          ],
        })
      );
    }

    // References
    if (claimElement.references && claimElement.references.length > 0) {
      // Header for grouped references & sources
      infringementParagraphs.push(
        new Paragraph({
          children: [
            new TextRun({ text: "References & Sources:", bold: true })
          ]
        })
      );

      // Show each reference with its corresponding source immediately after
      claimElement.references.forEach((ref: any) => {
        if (ref.reference) {
          infringementParagraphs.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: `• ${ref.reference}`,
                  italics: true
                })
              ]
            })
          );
        }
        if (ref.source) {
          infringementParagraphs.push(
            new Paragraph({
              children: [
                new ExternalHyperlink({
                  link: ref.source,
                  children: [
                    new TextRun({
                      text: ref.source,
                      style: "Hyperlink"
                    })
                  ]
                })
              ]
            })
          );
        }
      });
    }

    tableRows.push(new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph(claimElement.claim_element)],
        }),
        new TableCell({
          children: infringementParagraphs,
        }),
        new TableCell({
          children: index === 0
            ? [new Paragraph(` ${claimData.score}`)]
            : [],
        }),
      ],
    }));
  });

  const doc = new Document({
    sections: [{
      children: [
        new Paragraph({
          text: `${claimData.patent_number} vs. ${claimData.targeted_product}`,
          heading: HeadingLevel.HEADING_1,
        }),
        new Table({
          rows: tableRows,
          width: { size: 100, type: WidthType.PERCENTAGE },
        }),
      ],
    }],
  });

  Packer.toBlob(doc).then(blob => {
    saveAs(blob, `${claimData.patent_number}_vs_${claimData.targeted_product}.docx`);
  });
}
  openEditDialog(claimData: any): void {
    const dialogRef = this.dialog.open(EditClaimchartPopupComponent, {
      data: { claimData: claimData },
      backdropClass: 'blur-background',
      panelClass: 'custom-dialog-panel',
      width: '90vw !important',
    });
  
    dialogRef.afterClosed().subscribe(updatedData => {
      console.log('updated data:', updatedData);
      if (updatedData) {
        // Update the claim chart data with the edited values
        this.claimChartData = this.claimChartData.map((item: any) => {
          if (item.patent_number === claimData.patent_number && item.targeted_product === claimData.targeted_product) {
            return {
              ...claimData,
              data:updatedData
            }
          }
          return item;
        });
      this.dataService.updateDataSameStructure({...this.infringementData, claimChartData:this.claimChartData }, "infringement", false)
      }
    });
  }
  getLinkOrText(link: string): string {
    if(link.startsWith('http')){
      return `<a href="${link}" target="_blank" rel="noopener noreferrer">${link}</a>`;
    }
    else{
      return link;
    }
   }

    roundFirstTenth(value:number): number {
   if(value==null||value==undefined){
    value;
   }
    return Math.round(value* 10) / 10
   }
  

  
}